const config = {
    apiUrl: 'https://api-staging.playgolfhi.com',
    stripeKey: 'pk_test_V6ml8pBT0XEAVkWYOjmqOtyg',
    weatherIconsUrl: 'http://openweathermap.org/img/w',
    assetsUrl: 'https://s3-us-west-1.amazonaws.com/activiter-staging',
    sentryEnv: 'staging',
    chatUrl: 'https://chat-staging.playgolfhi.com'
};

export default config;
